import React, {useEffect} from "react";
import {useDispatch, useSelector} from "react-redux";
import {showPopUp} from "components/PopUp";
import SaveAsAssetPopup from "components/PopUp/SaveAsAssetPopup";
import {helperAction} from "store/actions/helper";
import {exportGlb, loadFile, loadGlb, saveFile, saveProject} from "store/actions/asset";
import {toggleAutoSave} from "store/actions/autoSave";
import {URL} from "utils";
import {MENU} from "../list";
import View from "./View";

export default function Container({menuType, handleMenu}) {
  const dispatch = useDispatch();
  const email = useSelector(state => state.userinfo.email);
  const isAutoSaveOn = useSelector(state => state.autoSave);
  const isHelperOn = useSelector(state => state.helper);
  const selectedObject = useSelector(state => state.asset.selectedObjects?.[0]);
  const version = useSelector(state => state.version.version);

  const searchParams = new URLSearchParams(window.location.search);

  const isAdmin = email?.includes("redbrick.space") || email?.includes("wizschool.io");

  const onClickAutoSave = () => {
    dispatch(toggleAutoSave());
  };

  const onClickHelperToggle = () => {
    dispatch(helperAction(!isHelperOn));
  };

  const onClickMenu = name => {
    switch (name) {
      case MENU.SAVE_TO_FILE:
        dispatch(saveFile("scene"));
        break;
      case MENU.SAVE_PROJECT:
        dispatch(saveProject());
        break;
      case MENU.OPEN_FROM_FILE:
        dispatch(loadFile("scene"));
        break;
      case MENU.IMPORT_GLB:
        dispatch(loadGlb());
        this.props.loadGlb();
        break;
      case MENU.EXPORT_GLB:
        dispatch(exportGlb());
        this.props.exportGlb();
        break;
      case MENU.SAVE_AS_ASSET:
        if (selectedObject) {
          showPopUp(<SaveAsAssetPopup />, {
            defaultPadding: false,
            noBackground: true,
          });
        } else {
          alert("에셋으로 저장할 오브젝트를 선택해주세요.");
        }
        break;
      case MENU.WIKI:
        window.open(URL.WIKI);
        break;
      case MENU.DISCORD:
        window.open(URL.DISCORD);
        break;
      default:
        break;
    }

    handleMenu();
  };

  return (
    <View
      menuType={menuType}
      isAdmin={isAdmin}
      isAutoSaveOn={isAutoSaveOn}
      isHelperOn={isHelperOn}
      onClickMenu={onClickMenu}
      onClickAutoSave={onClickAutoSave}
      onClickHelperToggle={onClickHelperToggle}
      version={version}
    />
  );
}
